import { Activityeditor } from '@linktivity/gds-neo';
import config from '../config';

const supplierApi = new Activityeditor.SupplierApi(config);

export default supplierApi;
